import React, { useState } from 'react';
import {
  Row,
  Col,
  Button,
  Input,
  Typography,
  Table,
  Tag,
  Skeleton,
  Result
  //   Space
} from 'antd';
import {
  FaSearch,
} from "react-icons/fa"; //Font Awesome 5
import { formatPhone, convertGrade } from '../../utils/customFunctions';
import CreateButton from '../../components/CreateButton';
import { useQuery } from '@tanstack/react-query';

const columns = [
  {
    title: 'Student ID',
    dataIndex: 'student_code',
    key: 'student_code',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/students/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text}
      </Button>
  },
  {
    title: 'Name',
    dataIndex: 'fname_th',
    key: 'fname_th',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/students/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text}
      </Button>
  },
  {
    title: 'Lastname',
    dataIndex: 'lname_th',
    key: 'lname_th',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/students/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text}
      </Button>
  },
  {
    title: 'Nickname',
    dataIndex: 'nick_name',
    key: 'nick_name',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/students/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text ?? "-"}
      </Button>
  },
  {
    title: 'Gender',
    dataIndex: 'gender',
    key: 'gender',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/students/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text}
      </Button>
  },
  // {
  //   title: 'Phone',
  //   dataIndex: 'phone',
  //   key: 'phone',
  //   render: (text, record) =>
  //     <Button
  //       type='text'
  //       href={`/admin/students/edit/${record._id}`}
  //       style={{
  //         width: "100%",
  //         background: 'none',
  //         textAlign: 'left'
  //       }}>
  //       {formatPhone(text)}
  //     </Button>
  // },
  {
    title: 'Phone No.',
    dataIndex: 'parent',
    key: 'parent',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/students/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {formatPhone(text.phone)}
      </Button>
  },
  {
    title: 'School',
    dataIndex: 'school',
    key: 'school',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/students/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text ?? "-"}
      </Button>
  },
  {
    title: 'Grade',
    dataIndex: 'grade',
    key: 'grade',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/students/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {convertGrade(text)}
      </Button>
  },
  {
    title: 'สถานะ',
    dataIndex: 'is_active',
    key: 'is_active',
    align: 'center',
    render: (_, record) => record.is_active ? <Tag color="green" style={{ borderRadius: '20px' }}>Actived</Tag> : <Tag color="red" style={{ borderRadius: '20px' }}>Inactive</Tag>
  },
  // {
  //   title: 'อีเมล์',
  //   dataIndex: 'email',
  //   key: 'email',
  //   render: (text, record) =>
  //     <Button
  //       type='text'
  //       href={`/admin/customers/edit/${record._id}`}
  //       style={{
  //         width: "100%",
  //         background: 'none',
  //         textAlign: 'left'
  //       }}>
  //       {text}
  //     </Button>
  // },
]


function List() {

  const [filterData, setFilterData] = useState(null);
  const { isLoading, isError, error, data } = useQuery({ queryKey: ['/api/students/'] })

  if (isLoading) {
    return <Skeleton active />
  }

  if (isError) {
    return <Result status="error" title={error.message} />
  };

  const onSearch = e => {
    const s = e.target.value;
    const target = data.filter(f => f.fname_th.includes(s) || f.nick_name?.includes(s) || f.parent.phone.includes(s) || f.school?.includes(s))
    // const target = data.filter(f => f.fname_th.includes(s) || f.nick_name.includes(s) || f.parent.phone.includes(s) || f.school.includes(s))
    setFilterData(target);
  }
  // console.log(data);
  return (
    <div>
      <Row gutter={[16, 16]} >
        <Col xs={24}>
          <Row justify='space-between'>
            <Col>
              <Typography.Title level={3}>
                Students
              </Typography.Title>
            </Col>
            <Col>
              <CreateButton linkTo='/admin/students/create' />
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={12} >
          <Input
            placeholder="Search Name Nickname Phone School"
            prefix={<FaSearch />}
            onChange={onSearch} />
        </Col>
        <Col xs={24}>
          <Table
            scroll={{
              x: 1200,
            }}
            rowKey={(record) => record._id}
            columns={columns}
            dataSource={filterData || data} />
        </Col>
      </Row>
    </div>
  )
}

export default List